import { types } from '../types/alertTypes';

type AlertPayload = {
	message?: string;
	title?: string;
	[key: string]: unknown;
};

const success = (payload: AlertPayload) => {
	return {
		type: types.success,
		payload,
	};
};

const warning = (payload: AlertPayload) => {
	return {
		type: types.warning,
		payload,
	};
};

const danger = (payload: AlertPayload) => {
	return {
		type: types.danger,
		payload,
	};
};

const remove = () => {
	return {
		type: types.remove,
		show: false,
		payload: {
			message: '',
			title: '',
		},
	};
};

const info = (payload: AlertPayload) => {
	return {
		type: types.info,
		payload,
	};
};

export const alertActions = {
	success,
	warning,
	danger,
	remove,
	info,
};
